module.exports = __webpack_public_path__ + "img/logo-not-fon.bfbd4aed.png";